import React, { useState } from 'react';
import SpeechComfortTestStartPage from './Start/SpeechComfortTestStartPage';
import SpeechComfortTestDetailPage from './Detail/SpeechComfortTestDetailPage';
import { GainUIMapping } from '../../../Models/HearingProfile/GainUIMapping';
import { withTracking } from '../../../Services/Monitoring/ApplicationInsights';
import { useSelector } from 'react-redux';
import { RootState } from '../../../Redux/Reducers/RootReducer';
import IDeviceState from '../../../Redux/Models/Device/IDeviceState';
import {
    ISpeechComfortTestContext,
    ISpeechComfortTestInfo,
    SpeechComfortTestContext,
} from './SpeechComfortTestContext';
import { SpeechComfortTestState } from './SpeechComfortTestModels';
import useSpeechComfortTestPageHandler from './SpeechComfortTestPageHandlerHook';
import ReturnToTimelineStateService, {
    ReturnToTimelineState,
} from '../../../Services/ReturnToTimelineService';

function SpeechComfortTestPage() {
    const deviceState = useSelector(
        (state: RootState) => state.device
    ) as IDeviceState;

    const [info, setInfo] = useState<ISpeechComfortTestInfo>({
        masterGain: new GainUIMapping([]),
        deviceState: deviceState,
        speechComfortTestState: SpeechComfortTestState.Start,
        previousLeftValue: 0,
        previousRightValue: 0,
        latestLeftValue: 0,
        latestRightValue: 0,
        loading: false,
    });
    const { exitSpeechComfort } = useSpeechComfortTestPageHandler();

    const initialValue: ISpeechComfortTestContext = {
        info: info,
        setSpeechComfortTestInfo: setInfo,
        exitSpeechComfort: exitSpeechComfort,
    };

    ReturnToTimelineStateService.setCurrentReturnToTimelineState(
        ReturnToTimelineState.SpeechComfort
    );

    const renderSwitch = (state: SpeechComfortTestState) => {
        window.scrollTo(0, 0);
        switch (state) {
            case SpeechComfortTestState.Start: {
                return <SpeechComfortTestStartPage />;
            }
            case SpeechComfortTestState.Detail: {
                return <SpeechComfortTestDetailPage />;
            }
            default: {
                return <></>;
            }
        }
    };

    return (
        <SpeechComfortTestContext.Provider value={initialValue}>
            {renderSwitch(info.speechComfortTestState)}
        </SpeechComfortTestContext.Provider>
    );
}

export default withTracking(SpeechComfortTestPage);
